function addGreyStars(ratingSnippet) {
  // Get the <span> element with the class "ruk-rating-snippet-count" inside each <div> element
  const ratingCountSpan = ratingSnippet.querySelector('.ruk-rating-snippet-count');

  // Check if the rating count is zero
  if (ratingCountSpan && ratingCountSpan.textContent === '(0)') {
    // Add the "grey-stars" class to the parent <div> element
    ratingSnippet.classList.add('grey-stars');
  }
}

// Wait for the DOM to finish loading
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Loop through each <div> element with the class "ruk_rating_snippet"
    const ratingSnippets = document.querySelectorAll('.ruk_rating_snippet');
    ratingSnippets.forEach(addGreyStars);

    // Use a MutationObserver to detect any new elements added to the DOM
    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        // Check if any new nodes have been added to the DOM
        if (mutation.type === 'childList') {
          // Check if any of the added nodes are <div> elements with the class "ruk_rating_snippet"
          const addedNodes = Array.from(mutation.addedNodes);
          const ratingSnippets = addedNodes.filter(node => node.nodeType === Node.ELEMENT_NODE && node.classList.contains('ruk_rating_snippet'));

          // If any new <div> elements have been added, call the addGreyStars function to check for zero ratings
          if (ratingSnippets.length > 0) {
            ratingSnippets.forEach(addGreyStars);
          }
        }
      }
    });

    // Observe changes to the entire document and its descendants
    observer.observe(document, { childList: true, subtree: true });
  }, 400);
});
